<template>
  <file-list
    v-model="attachments"
    :accept="acceptedDocumentFormats"
    :create-file="createFile"
    :disabled="disabled"
    :name-folder="nameFolder"
    :prefix-folder="prefixFolder"
    :remove-file="removeFile"
    prepend></file-list>
</template>

<script setup lang="ts">
import FileList from '@/components/FileList.vue'
import {
  attachmentCreate,
  attachmentDelete,
  attachmentList,
} from '@/requests/attachment'
import type { File } from '@/utils/types/helpers'
import { computed, ref, watch } from 'vue'

defineOptions({
  name: 'TaskFilesTab',
})

const props = defineProps<{
  taskId: number
  taskCreatedAt?: string
  disabled?: boolean
}>()

const nameFolder = computed(
  () =>
    props.taskCreatedAt?.substring(6, 10) || String(new Date().getFullYear())
)
const prefixFolder = computed(
  () =>
    props.taskCreatedAt?.substring(3, 5) ||
    String(new Date().getMonth() + 1).padStart(2, '0')
)
const acceptedDocumentFormats = ['.pdf', '.docx', '.xlsx', '.odt']
const attachments = ref<File[]>([])

const createFile = (file: File) => {
  return attachmentCreate('task', props.taskId, file)
}

const removeFile = (file: File) => {
  return attachmentDelete('task', props.taskId, Number(file.id))
}

watch(
  () => props.taskId,
  taskId => {
    if (!taskId) return

    attachmentList('task', taskId).then(res => {
      attachments.value = res
    })
  },
  { immediate: true }
)
</script>
